<pos-app-spinner [show]="(spinnerService.loading$ | async) || (loading$ | async) || (loadingFetchingOrderFromJDE$ | async)"></pos-app-spinner>
<div class="pb-5">
  <div class="text-center">
    <h3 class="pt-3 arb-large-heading">OPEN ARB ORDERS</h3>
  </div>
  <div class="col pt-2 mx-4">
    <div class="pb-2 d-flex">
      <div class="d-flex justify-content-between align-items-center w-100">
        <div>
          <input type="text" class="form-control" [(ngModel)]="searchValue" placeholder="Quick filter..." />
        </div>
        <div>
          <button class="btn btn-primary" (click)="exportGrid()">EXPORT GRID</button>
        </div>
      </div>
    </div>
    <ag-grid-angular
      #agGrid
      class="ag-theme-balham datagrid"
      [rowData]="rowData"
      [context]="context"
      [frameworkComponents]="frameworkComponents"
      [gridOptions]="gridOptions"
      (gridReady)="onGridReady($event)"
      [domLayout]="'autoHeight'"
      [pagination]="true"
      [paginationPageSize]="15"
      [quickFilterText]="searchValue"
    ></ag-grid-angular>
  </div>
</div>

<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h3 class="arb-large-heading" id="modal-basic-title">
      {{ isShowOrderAttachment ? 'ORDER ATTACHMENT ' : isShowSalesPersonSelector ? 'CHANGE SALESPERSON ON ORDER' : '' }}
    </h3>
  </div>
  <div *ngIf="isShowOrderAttachment">
    <div class="modal-body">
      <pos-app-attachment-files-notes
        [preloadAttachments]="allAttachments"
        [showActions]="internalUser ? true : false"
        [entityId]="entityId"
        [entityType]="entityType"
        (reloadedAttachments)="loadAllAttachments($event)"
        (closeActiveModal)="handleCloseAttachmentModel($event)"
        [orderDetails]="orderDetails"
      ></pos-app-attachment-files-notes>
    </div>
  </div>
  <div *ngIf="isShowSalesPersonSelector">
    <div class="modal-body">
      <pos-app-lib-customer-order-salesperson-selector
        [currentSalesPerson]="orderDetails?.salesPerson || orderDetails?.salesperson"
        [orderNumber]="orderDetails?.orderNumber"
        [orderType]="orderDetails?.orderType"
        [JDEOrderType]="orderDetails?.JDEOrderType"
        [JDECompany]="orderDetails?.JDECompany"
        [salesPeopleList]="salesPeopleList"
        (reloadData)="reloadData()"
        (closeActiveModal)="closeModal()"
      ></pos-app-lib-customer-order-salesperson-selector>
    </div>
  </div>
</ng-template>
